<template>
  <div class="range-bar">
    <RangeInputField
        :identifier="identifier + '-range-minmax'"
        :value="rangeMinMaxValue"
        v-model="rangeMinMaxValue"
        :max="max"
        :min="min"
        :step="0.1"
        @triggerFilter="triggerFilter()"
        @handleTracking="handleTracking()"
    ></RangeInputField>
  </div>
  <div class="range__range">
    <NumberInputField
        :identifier="identifier + '-minmax'"
        :value="rangeMinMaxValue"
        v-model="rangeMinMaxValue"
        :max="max"
        :min="min"
        @triggerFilter="triggerFilter()"
        @handleTracking="handleTracking()"></NumberInputField>
    <span>mm</span>
  </div>
</template>

<script setup>
import {computed, defineProps, defineEmits} from 'vue'
import NumberInputField from '@/components/form/NumberInputField.vue';
import RangeInputField from '@/components/form/RangeInputField.vue';

const props = defineProps({
  identifier: {
    type: String,
    default: ''
  },
  minMax: {
    type: Array,
    default: null
  },
  selectedRange: {
    type: Object,
    default: null
  },
  modelValue: {
    type: Array,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'handleTracking', 'update:modelValueMin', 'update:modelValueMax'])

const min = computed(() =>
{
  if (props.minMax.filter(el => el.min).length)
  {
    return parseFloat(props.minMax.filter(el => el.min)[0].min)
  }
  return null
})

const max = computed(() =>
{
  if (props.minMax.filter(el => el.max).length)
  {
    return parseFloat(props.minMax.filter(el => el.max)[0].max)
  }
  return null
})

const rangeMinMaxValue = computed({
  get () {
    return props.selectedRange.options[0].min
  },
  set (value) {
    if (value)
    {
      emit('update:modelValueMax', value)
      emit('update:modelValueMin', value)
    }
  }
})

function handleTracking (value)
{
  emit('handleTracking', value)
}

function triggerFilter()
{
  emit('update:modelValue')
}

</script>


